module.exports = __webpack_public_path__ + "img/gun-turret-gun-extension-mask.60829907.png";